import request from '../../axios';

const getLabDetail = async (lab_guid?: string) => {
  const {data}: {data: IGetLabDetail} = await request.get(
    `api/v2/store/lab-detail/${lab_guid}`,
  );
  return data;
};

export default getLabDetail;
